export interface ITeamGameBase {
  group: number;
  team: number;
}

export interface IAdminTeamGame extends ITeamGameBase {
  id: string;
  qualified: boolean;
  penalties: number;
}

export interface IAdminTeamGamesStore {
  [groupId: number]: IAdminTeamGame[];
}

export const adminTeamGamesStore: IAdminTeamGamesStore = {};
